
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/my-account",
      function () {
        return require("private-next-pages/help/my-account.tsx");
      }
    ]);
  